import React from 'react'

import { Tag } from 'antd'

type Props = {
  valid: boolean
  status: string
}

const MassachusettsContractorStatusDisplay = ({ valid, status }: Props) => {
  const color = valid ? 'green' : 'red'
  const label = status || (valid ? 'Valid' : 'Invalid')
  return <Tag color={color}>{label}</Tag>
}

export default React.memo(MassachusettsContractorStatusDisplay)
